import { useEffect, useState } from 'react';
import { sanityClient } from '../../../sanity.io/config';
import { TermsOfUseTypes } from './TermsOfUse.types';
import './TermsOfUse.styles.scss';
import LegalTitle from '../../atoms/Legal/LegalTitle/LegalTitle';
import LegalSubTitle from '../../atoms/Legal/LegalSubTitle/LegalSubTitle';
import LegalBody from '../../atoms/Legal/LegalBody/LegalBody';
import LegalHeroImage from '../../atoms/Legal/LegalHeroImage/LegalHeroImage';

function TermsOfUse() {
  const [termsOfUse, setTermsOfUse] = useState<TermsOfUseTypes>();

  useEffect(() => {
    sanityClient.fetch(`*[_type == "legal" && slug.current == "terms-of-use"]`).then(response => {
      if (response && response[0]) {
        setTermsOfUse(response[0]);
      }
    });
  }, []);

  return (
    <div className="terms-of-use">
      <LegalHeroImage src={termsOfUse?.heroImage?.asset?._ref} />
      <LegalTitle title={termsOfUse?.title} />
      <LegalSubTitle subTitle={termsOfUse?.body[0]?.children[0]?.text} />
      <LegalBody body={termsOfUse?.body} />
    </div>
  );
}

export default TermsOfUse;
